module.exports = "/_next/static/images/26-1-11b82546941cdf13e8a86cc8971e1281.jpg";